<label class="label">Expiry Duration</label>
<div class="duration-picker">
    <div class="duration-block">
        <div class="label">Days</div>
        <div class="input-container">
            <a class="btn btn-link" (click)="incrementOrDecrement('DECREMENT', config.labels.days)">
                <span class="bs-chevron bs-chevron-left"></span>
            </a>
            <input
                type="number"
                [ngModel]="days"
                (ngModelChange)="days = $event; onUserInteraction()"
                [placeholder]="config.labels.days"
                min="0"
                [max]="config.max.days" />
            <a class="btn btn-link" (click)="incrementOrDecrement('INCREMENT', config.labels.days)">
                <span class="bs-chevron bs-chevron-right"></span>
            </a>
        </div>
    </div>
    <div class="duration-block">
        <div class="label">Hours</div>
        <div class="input-container">
            <a class="btn btn-link" (click)="incrementOrDecrement('DECREMENT', config.labels.hours)">
                <span class="bs-chevron bs-chevron-left"></span>
            </a>
            <input
                type="number"
                [ngModel]="hours"
                (ngModelChange)="hours = $event; onUserInteraction()"
                [placeholder]="config.labels.hours"
                min="0"
                [max]="config.max.hours" />
            <a class="btn btn-link" (click)="incrementOrDecrement('INCREMENT', config.labels.hours)">
                <span class="bs-chevron bs-chevron-right"></span>
            </a>
        </div>
    </div>
    <div class="duration-block">
        <div class="label">Minutes</div>
        <div class="input-container">
            <a class="btn btn-link" (click)="incrementOrDecrement('DECREMENT', config.labels.minutes)">
                <span class="bs-chevron bs-chevron-left"></span>
            </a>
            <input
                type="number"
                [ngModel]="minutes"
                (ngModelChange)="minutes = $event; onUserInteraction()"
                [placeholder]="config.labels.minutes"
                min="0"
                [max]="config.max.minutes" />
            <a class="btn btn-link" (click)="incrementOrDecrement('INCREMENT', config.labels.minutes)">
                <span class="bs-chevron bs-chevron-right"></span>
            </a>
        </div>
    </div>
    <div class="duration-block">
        <div class="label">Seconds</div>
        <div class="input-container">
            <a class="btn btn-link" (click)="incrementOrDecrement('DECREMENT', config.labels.seconds)">
                <span class="bs-chevron bs-chevron-left"></span>
            </a>
            <input
                type="number"
                [ngModel]="seconds"
                (ngModelChange)="seconds = $event; onUserInteraction()"
                [placeholder]="config.labels.seconds"
                min="0"
                [max]="config.max.seconds" />
            <a class="btn btn-link" (click)="incrementOrDecrement('INCREMENT', config.labels.seconds)">
                <span class="bs-chevron bs-chevron-right"></span>
            </a>
        </div>
    </div>
</div>
